/**
 * スタンプ帳(称号)の島定義
 * 来場者画面で「5つの島」タップ導線として利用します。
 */

import ISLAND_STAMP_IMAGE_1 from '../../../assets/スタンプ/Stamp_5_01_1.png';
import ISLAND_STAMP_IMAGE_2 from '../../../assets/スタンプ/Stamp_5_02_2.png';
import ISLAND_STAMP_IMAGE_3 from '../../../assets/スタンプ/Stamp_5_03_3.png';
import ISLAND_STAMP_IMAGE_4 from '../../../assets/スタンプ/Stamp_5_04_4.png';
import ISLAND_STAMP_IMAGE_5 from '../../../assets/スタンプ/Stamp_5_05_5.png';
import ISLAND_ART_IMAGE_1 from '../../../assets/島/島1.png';
import ISLAND_ART_IMAGE_2 from '../../../assets/島/島2.png';
import ISLAND_ART_IMAGE_3 from '../../../assets/島/島3.png';
import ISLAND_ART_IMAGE_4 from '../../../assets/島/島4.png';
import ISLAND_ART_IMAGE_5 from '../../../assets/島/島5.png';

/** 島(エリア)定義 */
export const STAMP_ISLANDS = Object.freeze([
  {
    id: 'island-1',
    label: '第1島',
    locationValue: '第1島',
    titleName: '第1島マスター',
    accentClassName: 'bg-[#EAF6FF]',
    stampImageSource: ISLAND_STAMP_IMAGE_1,
    artImageSource: ISLAND_ART_IMAGE_1,
  },
  {
    id: 'island-2',
    label: '第2島',
    locationValue: '第2島',
    titleName: '第2島マスター',
    accentClassName: 'bg-[#FFF4C2]',
    stampImageSource: ISLAND_STAMP_IMAGE_2,
    artImageSource: ISLAND_ART_IMAGE_2,
  },
  {
    id: 'island-3',
    label: '第3島',
    locationValue: '第3島',
    titleName: '第3島マスター',
    accentClassName: 'bg-[#E7FFEA]',
    stampImageSource: ISLAND_STAMP_IMAGE_3,
    artImageSource: ISLAND_ART_IMAGE_3,
  },
  {
    id: 'island-4',
    label: '第4島',
    locationValue: '第4島',
    titleName: '第4島マスター',
    accentClassName: 'bg-[#EDE8FF]',
    stampImageSource: ISLAND_STAMP_IMAGE_4,
    artImageSource: ISLAND_ART_IMAGE_4,
  },
  {
    id: 'island-5',
    label: '第5島',
    locationValue: '第5島',
    titleName: '第5島マスター',
    accentClassName: 'bg-[#FFE7DD]',
    stampImageSource: ISLAND_STAMP_IMAGE_5,
    artImageSource: ISLAND_ART_IMAGE_5,
  },
]);

/**
 * islandId から島設定を取得する
 * @param {string} islandId - 島ID
 * @returns {typeof STAMP_ISLANDS[number] | null} 島設定
 */
export const findStampIsland = (islandId) => {
  const normalizedIslandId = typeof islandId === 'string' ? islandId.trim() : '';
  if (!normalizedIslandId) {
    return null;
  }

  return STAMP_ISLANDS.find((island) => island.id === normalizedIslandId) ?? null;
};

/**
 * 場所またはカテゴリから島設定を取得する
 * @param {string} locationValue - 場所またはカテゴリ
 * @returns {typeof STAMP_ISLANDS[number] | null} 島設定
 */
export const findStampIslandByLocationValue = (locationValue) => {
  /** 正規化済み場所 */
  const normalizedLocationValue = typeof locationValue === 'string' ? locationValue.trim() : '';

  if (!normalizedLocationValue) {
    return null;
  }

  return STAMP_ISLANDS.find((island) => island.locationValue === normalizedLocationValue) ?? null;
};

